// orderSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Order } from "../../entity/Order";

interface OrderState {
  orders: Order[];
  newOrderCount: number;
}

const initialState: OrderState = {
  orders: [],
  newOrderCount: -1,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrders: (state, action: PayloadAction<Order[]>) => {
      state.orders = action.payload;
    },
    incrementNewOrderCount: (state) => {
      state.newOrderCount += 1;
    },
    resetNewOrderCount: (state) => {
      state.newOrderCount = 0;
    },
    setNewOrderCount: (state, action: PayloadAction<number>) => {
      state.newOrderCount = action.payload;
    },
  },
});

export const {
  setOrders,
  incrementNewOrderCount,
  resetNewOrderCount,
  setNewOrderCount,
} = orderSlice.actions;
export default orderSlice.reducer;
